import Plaatjie from '@ubo/plaatjie'
import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import ParseContent from '../shared/ParseContent'
import BoxDefault from './BoxDefault'

const Section = styled.section`
  padding-bottom: 9rem;

  .grid {
    position: relative;
    display: grid;
    grid-template-columns: 3fr 2fr; /* First column takes 3/5 and second takes 2/5 of the total width */
    gap: 20px;

    img {
      object-fit: cover !important;
    }

    .grid-left {
      .gatsby-image-wrapper {
        height: 100%;
      }
    }

    .grid-right {
      display: flex;
      flex-direction: column;

      .gatsby-image-wrapper {
        height: 100%;
      }

      img {
        display: block;
        aspect-ratio: 16 / 9;
        height: 100%;
      }
    }

    .grid-right-description {
      margin-top: 1.25rem;
      background-color: #000;
      padding: 1.5rem !important;
      display: flex;
      flex-direction: column;
      height: auto !important;

      &:after {
        border-top-width: 50px !important;
        border-right-width: 50px !important;
      }

      * {
        color: #fff;
      }

      & h2 {
        font-size: 30px;
        line-height: 120%;
        font-weight: 400;

        @media (max-width: 575px) {
          font-size: 20px;
        }
      }

      ul {
        margin-bottom: 0 !important;
        @media (min-width: 576px) {
          min-height: 150px;
        }
      }

      & a {
        display: block;
      }

      & a > span {
        color: #d50021 !important;
      }
    }
  }

  @media (min-width: 992px) {
    .grid {
      width: 110%;
      left: -5%;

      .grid-right {
      }
    }
  }

  @media (max-width: 991.98px) {
    .grid {
      flex-direction: column;
      grid-template-columns: 1fr;
      gap: 0px;

      .grid-left {
        width: 100%;
        margin-block-end: 2rem;
      }
      .grid-right {
        width: 100%;
      }
    }
  }
`

function SingleProjectGallery({
  title,
  project,
  imageBig,
  imageSmall,
  description,
  link,
}) {
  return (
    <Section>
      <div className="container">
        <div className="pb-lg-5">
          <ParseContent content={title} />
        </div>
        <div className="grid">
          <div className="grid-left">
            <Plaatjie image={imageBig || project.projectrecap.gallerij[1]} />
          </div>
          <div className="grid-right">
            <Plaatjie image={imageSmall || project.projectrecap.gallerij[0]} />
            <BoxDefault className="grid-right-description">
              <div style={{ maxHeight: 180, overflow: 'hidden' }}>
                <ParseContent content={description} />
              </div>
              <div className="d-block pt-lg-3 mt-auto">
                {project && project.uri && (
                  <div className="d-flex justify-content-end mr-5">
                    <Link to={project.uri}>
                      <span>{`Bekijk het hele project >`}</span>
                    </Link>
                  </div>
                )}
                {link && link.url && (
                  <div className="d-flex justify-content-end mr-5">
                    <Link to={link.url} target="_blank">
                      <span>{`${link.title} >`}</span>
                    </Link>
                  </div>
                )}
              </div>
            </BoxDefault>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default SingleProjectGallery
